'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

function httpDeleteFactory(url) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments[2];

  function httpDelete(_ref) {
    var http = _ref.http,
        path = _ref.path,
        resolve = _ref.resolve;

    return (0, _utils.processResponse)(http.delete(resolve.value(url), resolve.value(query), options), path);
  }

  return httpDelete;
}

exports.default = httpDeleteFactory;
//# sourceMappingURL=httpDelete.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/http/lib/operators/httpDelete.js
// module id = 984
// module chunks = 5